(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /*
   * Product Card Modal
   * ---
   * Fetches the product page via the Section Rendering API
   * and injects it into the modal.
   */
  (function () {
    if (window.__productCardModalInit) return;
    window.__productCardModalInit = true;

    document.addEventListener('click', async (e) => {
      const trigger = e.target.closest('.product-card__modal-trigger');
      if (!trigger) return;

      e.preventDefault();

      const productUrl = trigger.dataset.productUrl;
      if (!productUrl) return;

      const productId = trigger.dataset.productId;
      const card = trigger.closest('product-card');
      const blockId = card ? card.id.replace('product-card-', '') : '';
      const modalId = `product-modal-${productId}-${blockId}`;
      const modal = document.getElementById(modalId);

      if (!modal) return;

      const body = modal.querySelector('.product-card-modal__body');
      const content = modal.querySelector('.product-card-modal__content');

      // Reset state
      body.classList.remove('is-loaded');
      content.innerHTML = '';

      // Open the modal
      modal.showModal();
      document.body.style.overflow = 'hidden';

      try {
        /*
         * Fetch the product page.
         * We use ?section_id=main-product to get just the main
         * product section via Shopify's Section Rendering API.
         * Adjust the section_id to match your theme's main
         * product section filename (e.g., 'main-product',
         * 'product-template', etc.).
         */
        const separator = productUrl.includes('?') ? '&' : '?';
        const fetchUrl = `${productUrl}${separator}section_id=main-product`;
        const res = await fetch(fetchUrl);
        const html = await res.text();

        content.innerHTML = html;
        body.classList.add('is-loaded');

        // Re-run any Shopify scripts that the injected section may need
        content.querySelectorAll('script').forEach((old) => {
          // Skip external scripts already loaded on the page
          if (old.src && document.querySelector(`script[src="${old.src}"]`)) {
            old.remove();
            return;
          }

          const s = document.createElement('script');

          // Preserve type="module" so ES import statements work
          if (old.type) {
            s.type = old.type;
          }

          if (old.src) {
            s.src = old.src;
          } else {
            s.textContent = old.textContent;
          }

          old.replaceWith(s);
        });
      } catch (err) {
        console.error('Product modal fetch error:', err);
        content.innerHTML =
          '<p style="text-align:center;padding:2rem;">Unable to load product details. <a href="' +
          productUrl +
          '">View product page →</a></p>';
        body.classList.add('is-loaded');
      }
    });

    // Close modal handlers
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-modal-close]')) {
        const modal = e.target.closest('.product-card-modal');
        if (modal) {
          modal.close();
          document.body.style.overflow = '';
        }
      }
    });

    // Close on Escape (native <dialog> handles this, but clean up overflow)
    document.addEventListener('close', (e) => {
      if (e.target.classList?.contains('product-card-modal')) {
        document.body.style.overflow = '';
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
